'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'circle-user';
var width = 512;
var height = 512;
var aliases = [62142,"user-circle"];
var unicode = 'f2bd';
var svgPathData = 'M415.4 435.4C409.1 370.6 354.5 320 288 320l-64 0C157.5 320 102.9 370.6 96.6 435.4 47.2 391.5 16 327.4 16 256 16 123.5 123.5 16 256 16S496 123.5 496 256c0 71.4-31.2 135.5-80.6 179.4zM400 448c-40.1 30.1-90 48-144 48s-103.9-17.9-144-48l0 0c0-61.9 50.1-112 112-112l64 0c61.9 0 112 50.1 112 112l0 0zM256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm80-320a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm-80-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCircleUser = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;